import React, { useEffect, useState } from "react";
import { ResponsiveBar } from "@nivo/bar";
import axios from "axios";
import dayjs from "dayjs";

export default function EnergyClubAssignedVsNotSubmitted() {
  const [barData, setBarData] = useState([]);
  const [schoolData, setSchoolData] = useState([]);
  const [activities, setActivities] = useState([]);
  const [subActivities, setSubActivities] = useState([]);
  const [clubs, setClubs] = useState([]);
  const [selectedActivity, setSelectedActivity] = useState("");
  const [selectedSubActivity, setSelectedSubActivity] = useState("");
  const [selectedClub, setSelectedClub] = useState("");
  const [selectedActivity2, setSelectedActivity2] = useState("");
  const [selectedFY1, setSelectedFY1] = useState("");
  const [selectedFY2, setSelectedFY2] = useState("");
  const [clubSearch, setClubSearch] = useState("");
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [clubLoading, setClubLoading] = useState(false);

  const getCurrentFinancialYear = () => {
    const today = new Date();
    const y = today.getFullYear();
    const m = today.getMonth() + 1;
    return m >= 4
      ? { label: `${y}-${y + 1}`, start: `${y}-04-01`, end: `${y + 1}-03-31` }
      : { label: `${y - 1}-${y}`, start: `${y - 1}-04-01`, end: `${y}-03-31` };
  };

  const financialYears = [
    { label: "2023-2024", start: "2023-04-01", end: "2024-03-31" },
    { label: "2024-2025", start: "2024-04-01", end: "2025-03-31" },
    { label: "2025-2026", start: "2025-04-01", end: "2026-03-31" },
    { label: "2026-2027", start: "2026-04-01", end: "2027-03-31" },
  ];

  const fetchActivities = async () => {
    const res = await axios.get("http://192.168.0.57:5000/api/activities");
    setActivities(res.data);
  };

  const fetchClubs = async (searchTerm = "") => {
    try {
      setClubLoading(true);
      const res = await axios.get("http://192.168.0.57:5000/api/energy-club-list", {
        params: { search: searchTerm },
      });
      setClubs(res.data || []);
    } finally {
      setClubLoading(false);
    }
  };

  const fetchSubActivities = async (activityId) => {
    if (!activityId) {
      setSubActivities([]);
      setSelectedSubActivity("");
      return;
    }
    const res = await axios.get("http://192.168.0.57:5000/api/subactivities", {
      params: { activity_id: activityId },
    });
    setSubActivities(res.data);
  };

  const fetchChart1 = async (fyObj = null) => {
    const fy =
      fyObj ||
      financialYears.find((f) => f.label === selectedFY1) ||
      getCurrentFinancialYear();

    setLoading1(true);
    try {
      const res = await axios.get(
        "http://192.168.0.57:5000/api/energy-club-status-financialyear",
        {
          params: {
            club_id: "7723",
            fy_start: fy.start,
            fy_end: fy.end,
            activity_id: selectedActivity || undefined,
            subActivity_id: selectedSubActivity || undefined,
          },
        }
      );

      const grouped = {};
      res.data.forEach((r) => {
        const month = dayjs(r.monthyear + "-01").format("MMM YYYY");
        const assigned = Number(r.total_assigned || 0);
        const submitted = Number(r.total_submitted || 0);
        const notSubmitted = Math.max(assigned - submitted, 0);

        if (!grouped[month])
          grouped[month] = {
            month,
            Assigned: 0,
            "Not Submitted": 0,
            percent: 0,
          };

        grouped[month].Assigned += assigned;
        grouped[month]["Not Submitted"] += notSubmitted;
        grouped[month].percent = assigned > 0 ? ((notSubmitted / assigned) * 100).toFixed(1) : 0;
      });

      setBarData(Object.values(grouped));
    } finally {
      setLoading1(false);
    }
  };

  const fetchChart2 = async (fyObj = null) => {
    const fy =
      fyObj ||
      financialYears.find((f) => f.label === selectedFY2) ||
      getCurrentFinancialYear();

    setLoading2(true);
    try {
      const res = await axios.get(
        "http://192.168.0.57:5000/api/monthly-school-submissions-fy",
        {
          params: {
            fy_start: fy.start,
            fy_end: fy.end,
            club_id: selectedClub || undefined,
            activity_id: selectedActivity2 || undefined,
          },
        }
      );

      const formatted = res.data.map((r) => {
        const total = Number(r.total_schools || 0);
        const submitted = Number(r.submitted_schools || 0);
        const notSubmitted = Math.max(total - submitted, 0);
        const percent =
          total > 0 ? ((notSubmitted / total) * 100).toFixed(1) : 0;
        return {
          month: r.month,
          Assigned: total,
          "Not Submitted": notSubmitted,
          percent,
        };
      });

      setSchoolData(formatted);
    } finally {
      setLoading2(false);
    }
  };

  useEffect(() => {
    const currentFY = getCurrentFinancialYear();
    setSelectedFY1(currentFY.label);
    setSelectedFY2(currentFY.label);
    fetchActivities();
    fetchChart1(currentFY);
    fetchChart2(currentFY);
  }, []);

  useEffect(() => {
    fetchSubActivities(selectedActivity);
  }, [selectedActivity]);

  const CustomTooltip = ({ id, value, indexValue, data }) => (
    <div
      style={{
        background: "#fff",
        border: "1px solid #ccc",
        padding: "8px",
        borderRadius: "6px",
        fontSize: "13px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
      }}
    >
      <strong>{indexValue}</strong>
      <br />
      {id}: {value}
      <br />
      <span style={{ color: "#FF7043" }}>
        Not Submitted %: {data.percent}%
      </span>
    </div>
  );

  const barSettings = {
    keys: ["Assigned", "Not Submitted"],
    indexBy: "month",
    groupMode: "grouped",
    colors: ["#FFCE56", "#FF7043"],
    margin: { top: 50, right: 30, bottom: 100, left: 70 },
    padding: 0.3,
    axisBottom: { tickRotation: -35, legend: "Month", legendOffset: 60 },
    axisLeft: { legend: "Count", legendOffset: -50 },
    tooltip: CustomTooltip,
  
    // ✅ Label styling section
    label: d => d.value,
    labelSkipHeight: 12,
    labelTextColor: "#000",
    labelPosition: "inside",
    labelYOffset: 0,
  
    // ✅ Add this custom label rotation using renderLayer
    layers: [
      "grid",
      "axes",
      "bars",
      "markers",
      "legends",
      (props) =>
        props.bars.map((bar) => (
          <text
            key={bar.key}
            x={bar.x + bar.width / 2}
            y={bar.y + bar.height / 2}
            textAnchor="middle"
            dominantBaseline="central"
            transform={`rotate(-90, ${bar.x + bar.width / 2}, ${bar.y + bar.height / 2})`}
            style={{
              fill: "#000",
              fontSize: 11,
              fontWeight: "bold",
            }}
          >
            {bar.data[bar.key]}
          </text>
        )),
    ],
  
    legends: [
      {
        dataFrom: "keys",
        anchor: "bottom",
        direction: "row",
        translateY: 80,
        itemsSpacing: 10,
        itemWidth: 140,
        itemHeight: 20,
        symbolSize: 18,
      },
    ],
  };
  

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "30px",
        background: "#f4f6f8",
        padding: "30px",
        minHeight: "100vh",
      }}
    >
      {/* Chart 1 */}
      <div
        style={{
          background: "#fff",
          borderRadius: "12px",
          padding: "25px",
          boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
        }}
      >
        <h2 style={{ textAlign: "center", color: "#222" }}>
          Assigned vs Not Submitted by Own School (FY {selectedFY1})
        </h2>

        {/* Filters */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            marginBottom: "15px",
          }}
        >
          <select
            value={selectedFY1}
            onChange={(e) => setSelectedFY1(e.target.value)}
            style={{ flex: 1, padding: "8px" }}
          >
            {financialYears.map((fy) => (
              <option key={fy.label} value={fy.label}>
                {fy.label}
              </option>
            ))}
          </select>

          <select
            value={selectedActivity}
            onChange={(e) => setSelectedActivity(e.target.value)}
            style={{ flex: 1, padding: "8px" }}
          >
            <option value="">All Activities</option>
            {activities.map((a) => (
              <option key={a.activities_id} value={a.activities_id}>
                {a.activity}
              </option>
            ))}
          </select>

          <select
            value={selectedSubActivity}
            onChange={(e) => setSelectedSubActivity(e.target.value)}
            style={{ flex: 1, padding: "8px" }}
            disabled={!selectedActivity}
          >
            <option value="">All Sub-Activities</option>
            {subActivities.map((sa) => (
              <option key={sa.sub_activity_id} value={sa.sub_activity_id}>
                {sa.sub_activity_name}
              </option>
            ))}
          </select>

          <button
            onClick={() => fetchChart1()}
            style={{
              background: "#FF7043",
              color: "#fff",
              border: "none",
              padding: "8px 12px",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            Search
          </button>
        </div>

        <div style={{ height: 400 }}>
          {loading1 ? (
            <p style={{ textAlign: "center", marginTop: "150px" }}>Loading...</p>
          ) : (
            <ResponsiveBar data={barData} {...barSettings} />
          )}
        </div>
      </div>

      {/* Chart 2 */}
      <div
        style={{
          background: "#fff",
          borderRadius: "12px",
          padding: "25px",
          boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
        }}
      >
        <h2 style={{ textAlign: "center", color: "#222" }}>
          Assigned vs Not Submitted by All Schools (FY {selectedFY2})
        </h2>

        {/* Filters */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            marginBottom: "15px",
          }}
        >
          <select
            value={selectedFY2}
            onChange={(e) => setSelectedFY2(e.target.value)}
            style={{ flex: 1, padding: "8px" }}
          >
            {financialYears.map((fy) => (
              <option key={fy.label} value={fy.label}>
                {fy.label}
              </option>
            ))}
          </select>

          <input
            type="text"
            value={clubSearch}
            onChange={(e) => {
              const val = e.target.value;
              setClubSearch(val);
              if (val.length >= 2) fetchClubs(val);
              else setClubs([]);
            }}
            placeholder="🔍 Search School..."
            style={{ flex: 1, padding: "8px" }}
          />

          <select
            value={selectedClub}
            onChange={(e) => setSelectedClub(e.target.value)}
            style={{ flex: 1, padding: "8px" }}
          >
            <option value="">All Schools</option>
            {clubs.map((c) => (
              <option key={c.enrclub_id} value={c.enrclub_id}>
                {c.enr_club_name}
              </option>
            ))}
          </select>

          <select
            value={selectedActivity2}
            onChange={(e) => setSelectedActivity2(e.target.value)}
            style={{ flex: 1, padding: "8px" }}
          >
            <option value="">All Activities</option>
            {activities.map((a) => (
              <option key={a.activities_id} value={a.activities_id}>
                {a.activity}
              </option>
            ))}
          </select>

          <button
            onClick={() => fetchChart2()}
            style={{
              background: "#FF7043",
              color: "#fff",
              border: "none",
              padding: "8px 12px",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            Search
          </button>
        </div>

        <div style={{ height: 400 }}>
          {loading2 ? (
            <p style={{ textAlign: "center", marginTop: "150px" }}>Loading...</p>
          ) : (
            <ResponsiveBar data={schoolData} {...barSettings} />
          )}
        </div>
      </div>
    </div>
  );
}
